import { render, staticRenderFns } from "./summaryInstagram.vue?vue&type=template&id=041b388c&scoped=true&"
import script from "./summaryInstagram.vue?vue&type=script&lang=js&"
export * from "./summaryInstagram.vue?vue&type=script&lang=js&"
import style0 from "./summaryInstagram.vue?vue&type=style&index=0&id=041b388c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b388c",
  null
  
)

export default component.exports